import React, { useContext } from 'react';
import { authContext } from '../../context/AuthContext';
import RestaurantMenuOutlinedIcon from '@mui/icons-material/RestaurantMenuOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import { Sidebar, Menu, MenuItem, menuClasses, SubMenu } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';
import SidebarLink from './SidebarLinks';
import { SidebarContext } from '../../context/SidebarContext';

export default function MainApp({ mobileSidebar }) {
    const { isOpen } = useContext(SidebarContext)
    const { userRole } = useContext(authContext)
    console.log('userrole; ', userRole)
    const location = useLocation();
    const pages = [
        {
            icon: <ReceiptLongIcon fontSize="small" />, name: 'Payroll', link: '/time-sheet-landing', render: true,
            subFolder: []
        },
        {
            icon: <RestaurantMenuOutlinedIcon fontSize="small" />, name: 'Items', link: '/item-sales',
            render: false,
            subFolder: []
        },
        {
            icon: <StoreOutlinedIcon fontSize="small" />, name: 'Cashier Sale', link: '/cashier-sales', render: true,
            subFolder: []
        },
        {
            icon: <AssessmentOutlinedIcon fontSize="small" />, name: 'All Store Report', link: '/all-store-sales',
            render: userRole === 'SuperAdmin' ? true : false,
            subFolder: []
        },
    ]

    return (
        // <div className="sidebar">
        //     <div className='row'>
        //         {pages.map((pg, ind) => (
        //             <div style={{ position: "relative",/* top: "5%",*/ left: "10px" }}>
        //                 <div className='row' >
        //                     <SidebarLink
        //                         navLink={pg.link}
        //                         icon={pg.icon}
        //                         name={pg.name}
        //                         subpage={pg.subFolder}
        //                         partnerHub={true}
        //                     />
        //                 </div>
        //             </div>
        //         ))}
        //     </div>


        // </div >
        <Sidebar
            collapsed={!isOpen}
            rootStyles={{
                paddingTop: '12px',
                width: '200px',
                height: '100%',
                border: 'none',
                fontSize: '14px', // Your font size,
                ['.ps-sidebar-container']: {
                    background: 'none !important',
                    backgroundColor: 'transparent !important',
                },
                ['.ps-menu-button']: {
                    /* border-radius: 10px; */
                    height: "40px !important"
                },
                // ['.ps-submenu-content']: {
                //     /* border-radius: 10px; */
                //     zIndex: "1000"
                // }
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                {/* Main Navigation Group */}
                <div style={{ flex: '.98 1 0' }}>
                    <Menu
                        menuItemStyles={{
                            button: ({ active }) => ({
                                backgroundColor: active ? '#1a6df233' : 'transparent',
                                color: 'black',
                                '&:hover': {
                                    backgroundColor: 'lightgray',
                                },
                            }),
                            subMenuContent: ({ level, collapsed }) => ({
                                // This styles the "popup" container in collapsed mode
                                backgroundColor: '#ffffff',
                                // boxShadow: collapsed ? '0px 4px 12px rgba(0,0,0,0.1)' : 'none',
                                // borderRadius: collapsed ? '8px' : '0px',
                                // marginLeft: collapsed ? '10px' : '0px',
                                zIndex: collapsed && '10000'
                            }),
                            root: ({ level, active, collapsed }) => {
                                if (collapsed) {
                                    return {
                                        marginBottom: '10px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                    };
                                }
                            },
                        }}
                    >
                        {/* {pages
                            .filter(pg => pg.render)
                            .map((pg) => (
                                <MenuItem
                                    key={pg.link}
                                    active={location.pathname === pg.link}
                                    component={<Link to={pg.link} />}
                                    icon={pg.icon}
                                >
                                    {pg.name}
                                </MenuItem>
                            ))} */}
                        {pages
                            .filter(pg => pg.render)
                            .map((pg) => {
                                const isParentActive = location.pathname.startsWith(pg.link);
                                // Logic: If subFolder has items, render a SubMenu
                                if (pg.subFolder.length > 0) {
                                    return (
                                        <SubMenu
                                            key={pg.name}
                                            label={pg.name}
                                            icon={pg.icon}
                                            // Keeps submenu open if one of its children is active
                                            defaultOpen={pg.subFolder.some(sub => location.pathname === sub.link)}
                                        >
                                            {pg.subFolder.map((sub) => (
                                                <MenuItem
                                                    key={sub.link}
                                                    active={isParentActive}
                                                    component={<Link to={sub.link} />}
                                                >
                                                    {sub.name}
                                                </MenuItem>
                                            ))}
                                        </SubMenu>
                                    );
                                }

                                // Logic: If no subFolder, render standard MenuItem
                                return (
                                    <MenuItem
                                        key={pg.link}
                                        active={isParentActive}
                                        component={<Link to={pg.link} />}
                                        icon={pg.icon}
                                    >
                                        {pg.name}
                                    </MenuItem>
                                );
                            })}
                    </Menu>
                </div>


            </div>
        </Sidebar >
    )
}